import BaseStore from 'stores/base'

export default class ClientRequesterStore extends BaseStore {
  constructor(api, options) {
    super(api)
    this.api = api
    this.options = options
  }
}
